import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDocumentation = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M28 4H12C9.8 4 8.02 5.8 8.02 8L8 40c0 2.2 1.78 4 3.98 4H36c2.2 0 4-1.8 4-4V16zm4 32H16v-4h16zm0-8H16v-4h16zm-6-10V7l11 11z" })
});
export default SvgDocumentation;
